import { AdSlotConfig, AdSlotId } from './types';

export const AD_SLOT_CONFIGS: Record<AdSlotId, AdSlotConfig> = {
  'ad-leaderboard': {
    id: 'ad-leaderboard',
    label: 'Leaderboard',
    location: 'Top of page, below nav bar',
    minHeight: { desktop: 250, tablet: 90 },
    sizes: {
      desktop: ['970x250', '728x90'],
      tablet: ['728x90'],
    },
    visibleOn: ['desktop', 'tablet'],
  },

  'ad-section-leaderboard-1': {
    id: 'ad-section-leaderboard-1',
    label: 'Section Leaderboard 1',
    location: 'In between every 5 rows',
    minHeight: { desktop: 250, tablet: 90, mobile: 250 },
    sizes: {
      desktop: ['970x250', '728x90'],
      tablet: ['728x90'],
      mobile: ['300x250'],
    },
    visibleOn: ['desktop', 'tablet', 'mobile'],
  },

  'ad-section-leaderboard-2': {
    id: 'ad-section-leaderboard-2',
    label: 'Section Leaderboard 2',
    location: 'In between every 5 rows',
    minHeight: { desktop: 250, tablet: 90, mobile: 250 },
    sizes: {
      desktop: ['970x250', '728x90'],
      tablet: ['728x90'],
      mobile: ['300x250'],
    },
    visibleOn: ['desktop', 'tablet', 'mobile'],
  },

  'ad-section-leaderboard-3': {
    id: 'ad-section-leaderboard-3',
    label: 'Section Leaderboard 3',
    location: 'In between every 5 rows',
    minHeight: { desktop: 250, tablet: 90, mobile: 250 },
    sizes: {
      desktop: ['970x250', '728x90'],
      tablet: ['728x90'],
      mobile: ['300x250'],
    },
    visibleOn: ['desktop', 'tablet', 'mobile'],
  },

  'ad-boa-leaderboard': {
    id: 'ad-boa-leaderboard',
    label: 'Bottom of Article Leaderboard',
    location: 'Bottom of page',
    minHeight: { desktop: 250, tablet: 90 },
    sizes: {
      desktop: ['970x250', '728x90'],
      tablet: ['728x90'],
    },
    visibleOn: ['desktop', 'tablet'],
  },

  // Exception: 90px min-height on both desktop and tablet
  'ad-inarticle-leaderboard': {
    id: 'ad-inarticle-leaderboard',
    label: 'In-Article Leaderboard',
    location: 'Beneath the pitch & key',
    minHeight: { desktop: 90, tablet: 90 },
    sizes: {
      desktop: ['728x90'],
      tablet: ['728x90'],
    },
    visibleOn: ['desktop', 'tablet'],
  },

  'ad-sidebar-mpu': {
    id: 'ad-sidebar-mpu',
    label: 'Sidebar MPU',
    location: 'Right hand side content',
    minHeight: { desktop: 250, tablet: 250 },
    sizes: {
      desktop: ['300x250', '300x600'],
      tablet: ['300x250', '300x600'],
    },
    visibleOn: ['desktop', 'tablet'],
  },

  'ad-section-league': {
    id: 'ad-section-league',
    label: 'Section League',
    location: 'In between league rows',
    minHeight: { mobile: 50 },
    sizes: {
      mobile: ['320x50'],
    },
    visibleOn: ['mobile'],
  },

  'ad-section-transfer': {
    id: 'ad-section-transfer',
    label: 'Section Transfer',
    location: 'Transfer summary',
    minHeight: { mobile: 50 },
    sizes: {
      mobile: ['320x50'],
    },
    visibleOn: ['mobile'],
  },

  // Exception: 50px min-height, fixed to bottom of viewport
  'ad-sticky-leaderboard': {
    id: 'ad-sticky-leaderboard',
    label: 'Sticky Leaderboard',
    location: 'Sticky banner at bottom of screen',
    minHeight: { mobile: 50 },
    sizes: {
      mobile: ['320x50'],
    },
    visibleOn: ['mobile'],
    sticky: true,
  },
};
